// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260035/js/" + chunkId + "." + {"44":"2ab9223e","225":"83fb10ab","481":"b8188327","486":"fe5d3268","770":"6312c8d3"}[chunkId] + ".0.21785359194868859.chunk.js";
};